var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnit1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4198_43315)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 56.2338C16.3858 51.055 19.9461 54.615 14.7671 71C24.3364 54.615 46.6637 54.615 56.2331 71C51.0575 54.615 54.6182 51.055 71 56.2338C54.6182 46.6647 54.6182 24.3389 71 14.7701C54.6182 19.945 51.0575 16.3849 56.2331 0C46.6637 16.3849 24.3364 16.3849 14.7671 0C19.9461 16.3849 16.3858 19.945 0 14.7701C16.3858 24.3389 16.3858 46.6647 0 56.2338ZM35.5 48.635C42.7544 48.635 48.635 42.7544 48.635 35.5C48.635 28.2458 42.7544 22.365 35.5 22.365C28.2458 22.365 22.365 28.2458 22.365 35.5C22.365 42.7544 28.2458 48.635 35.5 48.635Z",
    fill: "#A6F4C5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4198_43315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnit1);
export default __webpack_public_path__ + "static/media/unit-1.8775b3a952d1a5bbbdad108cde759d10.svg";
export { ForwardRef as ReactComponent };